module.exports = __webpack_public_path__ + "static/media/activate.11bc7775.svg";